import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, withHistory } from "@openimis/fe-core";
import InsureeEnrollmentSearcher from "../../components/InsureeEnrollmentSearcher";

const styles = (theme) => ({
  page: theme.page,
});

class InsureeEnrollmentHomePage extends Component {
  onDoubleClick = (enrollment) => {
    if (this.props.history && enrollment?.uuid) {
      this.props.history.push(`/enrollment/insuree/${enrollment.uuid}/detail`);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <InsureeEnrollmentSearcher
          cacheFiltersKey="enrollmentInsureePageFiltersCache"
          onDoubleClick={this.onDoubleClick}
        />
      </div>
    );
  }
}

export default injectIntl(
  withModulesManager(
    withHistory(
      withTheme(withStyles(styles)(InsureeEnrollmentHomePage))
    )
  )
);
